(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mbd-mix-set"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mbd-mix-set')) {
  customElements.define('mbd-mix-set', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.catalog = JSON.parse(this.querySelector('[data-mix-catalog]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.messages = JSON.parse(this.querySelector('[data-mix-messages]').textContent);
      this.choices = [...this.querySelectorAll('[data-choice]')];
      this.form = this.querySelector('form');
      this.choices.forEach(select => this.catalog.choices.forEach((choice, index) => {
        const option = document.createElement('option');
        option.value = choice.name;
        option.textContent = choice.name;
        option.dataset.index = index;
        select.append(option);
      }));
      this.addEventListener('change', () => this.sync());
      this.form.addEventListener('submit', event => {
        this.sync();
        if (!this.querySelector('[data-variant-id]').value || !this.form.reportValidity()) event.preventDefault();
      });
      this.sync();
    }
    sync() {
      const size = this.catalog.coasters ? 4 : Number(this.querySelector('.mbd-mix-sizes input:checked').value);
      const counts = Array(this.catalog.choices.length).fill(0);
      let filled = 0;
      this.choices.forEach((select, index) => {
        const active = index < size;
        select.disabled = !active;
        select.required = active;
        select.closest('[data-slot]').hidden = !active;
        const choiceIndex = this.catalog.choices.findIndex(choice => choice.name === select.value);
        const photo = select.closest('[data-slot]').querySelector('img');
        photo.hidden = choiceIndex < 0;
        if (choiceIndex >= 0) {
          photo.src = this.catalog.choices[choiceIndex].image;
          photo.alt = this.catalog.choices[choiceIndex].name;
          if (active) { counts[choiceIndex]++; filled++; }
        }
      });
      const sku = this.catalog.baseSku || this.catalog.prefix + counts.join('-');
      const variant = filled === size ? this.variants.find(v => v.sku === sku) : null;
      const available = Boolean(variant && variant.available);
      this.querySelector('[data-variant-id]').value = available ? variant.id : '';
      this.querySelector('[type="submit"]').disabled = !available;
      this.querySelector('[data-status]').textContent = available ? this.messages.ready : filled < size ? this.messages.complete : this.messages.unavailable;
      const price = this.catalog.coasters ? 28 : size === 4 ? 30 : 16;
      this.querySelector('[data-price]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:this.dataset.currency}).format(price);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
